import script from "./product-feature-badges.vue?vue&type=script&setup=true&lang=js"
export * from "./product-feature-badges.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__